/**
 * Цвета кнопок «плюс/минус» и старт/реверс на пульте табло. Не заведены в общей теме —
 * это фирменные цвета конкретно пульта, а не часть админ-палитры.
 */
export const BOARD_MASTER_POSITIVE_COLOR = '#48D274';
export const BOARD_MASTER_NEGATIVE_COLOR = '#D2472F';
